<template>
  <b-form-group
    label="Para Birimi"
    label-for="id_currencies"
  >
    <validation-provider
      #default="{ errors }"
      name="Para Birimi"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_currencies"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Para Birimi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CurrenciesSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['currencies/dataList']
    },
    dataItem() {
      return this.$store.getters['servicePrices/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('currencies/getDataList')
    },
  },
}
</script>
